// extracted by mini-css-extract-plugin
module.exports = {"card":"CardFeatured_card__Hr9Mq","card__content":"CardFeatured_card__content__o1tbD","card__title":"CardFeatured_card__title__3-Y_Y"};